var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_3671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.40005C23.496 2.40005 29.6 8.50405 29.6 16C29.6 23.496 23.496 29.6 16 29.6C8.50405 29.6 2.40005 23.496 2.40005 16C2.40005 8.50405 8.50405 2.40005 16 2.40005ZM16 0.800049C7.60805 0.800049 0.800049 7.60805 0.800049 16C0.800049 24.392 7.60805 31.2 16 31.2C24.392 31.2 31.2 24.392 31.2 16C31.2 7.60805 24.392 0.800049 16 0.800049Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 21.3441C15.3361 21.3441 14.8001 20.8081 14.8001 20.1441V16.1601L15.6401 15.8961C18.2561 15.0801 18.8081 13.3681 18.8081 12.0801C18.8081 10.7361 17.8241 9.31205 16.0001 9.31205C14.5201 9.31205 13.4801 10.0641 13.1521 11.3761C12.9921 12.0161 12.3441 12.4081 11.6961 12.2481C11.0561 12.0881 10.6641 11.4401 10.8241 10.7921C11.4241 8.39205 13.4001 6.90405 16.0001 6.90405C19.2641 6.90405 21.2081 9.52805 21.2081 12.0721C21.2081 14.7121 19.7601 16.7841 17.2001 17.8641V20.1361C17.2001 20.8001 16.6641 21.3441 16.0001 21.3441Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 26.2321C16.9456 26.2321 17.7121 25.4656 17.7121 24.5201C17.7121 23.5746 16.9456 22.8081 16.0001 22.8081C15.0546 22.8081 14.2881 23.5746 14.2881 24.5201C14.2881 25.4656 15.0546 26.2321 16.0001 26.2321Z",
    fill: "#353EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_3671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.b2204f1707de2419d3e4bcac250a56f1.svg";
export { ForwardRef as ReactComponent };